import { Link } from "react-router-dom";
import "../../styles/BookPreview.css";

export default function BookPreview({ id, title, coverImage, shortDescription }) {
  return (
    <div className="book-preview">
      <Link className="book-preview-image" to={`/books/${title}`}>
        <img src={coverImage} alt={title} className="book-cover" />
      </Link>
      <h3>{title}</h3>
      <p>{shortDescription}</p>
      <Link to={`/books/${title}`} className="learn-more-button">Learn More</Link>
    </div>
  );
}